import { useState, useEffect } from "react";

import { useInvoiceContext } from "../createInvoiceContext";
import { getAdditions } from "../../../api/logistic";
import { Toggle } from "rsuite";
import { useTranslation } from "react-i18next";

import "./additionsInvoice.css";
import BasicNumberInput from "../../../components/basicNumberInput/basicNumberInput";
import BasicCheckbox from "../../../components/basicCheckbox/basicCheckbox";
import { getCurrencySymbol } from "../../../utils/currencyHelper";
import { getCurrencyRate } from "../../../api/currency";


const MOCK_FORM_DATA = {
    places: [
        {
            "number": 1,
            "weight": 35,
            "length": 2,
            "width": 2,
            "height": 2,
            "goods": [
                {
                    "name": "ТНП",
                    "price": 1,
                    "quantity": 10,
                    "weight": 20,
                    "article": "",
                    "price_alter_vat": 0,
                    "vat_rate": 1,
                    "vat_sum": 0
                }
            ]
        }
    ],
    selected_mode: 3
};

const LABELS = {
    "BUBBLE_WRAP": "Длина, м.",
    "GET_UP": "Этаж"
}

const AdditionItemBox = ({setRefresh, additions, item, convertPrice = (price) => price}) => {
    const { invoiceData, setInvoiceData } = useInvoiceContext();
    const { t } = useTranslation('basic');
    const currencySymbol = getCurrencySymbol(invoiceData?.user_info);

    return (
        <div className="additionItem">
            <div className="additionItemWrapper">
                <div className={`additionItemHeader ${invoiceData.additions.BOX > 0 ? "active" : ""}`}>
                    <div className="paragraph-14R">{t('BOX')}</div>
                    <div className="paragraph-12R">
                        {
                        }
                    </div>
                </div>
                <div className="additionItemToggle">
                    <Toggle color="green" size="xs" checked={invoiceData.additions.BOX > 0} onChange={(e) => {
                        setInvoiceData(oldData => {

                            const newData = {...oldData};
                            if (e) {
                                newData.additions.BOX = 1;
                            } else {
                                delete newData.additions.BOX;
                                // del all carton boxes if box is unchecked
                                Object.keys(additions).map((v, i) => {
                                    if (v.startsWith("CARTON_BOX")) {
                                        delete newData.additions[v];
                                    }
                                });
                            }

                            return newData
                        });
                        setRefresh(oldData => oldData + 1);
                    }} />
                </div>
            </div>
            {
                invoiceData.additions.BOX ?
                Object.keys(additions).map((v, i) => {
                    if (!v.startsWith("CARTON_BOX")) return;

                    return (
                        <BasicNumberInput
                            fluid
                            spaced
                            value={invoiceData.additions[v]}
                            onChange={(d) => {
                                setInvoiceData(oldData => {
                                    const newData = {...oldData};
                                    newData.additions[v] = d;
                                    return newData
                                });
                                setRefresh(oldData => oldData + 1);
                            }}
                            label={
                                <div className="additionItemBox">
                                    <div className="paragraph-14R">{t(v)}</div>
                                    <div className="paragraph-12R" style={{color: `var(--Gray-${invoiceData.additions[v] ? 8 : 6}00) !important`}}>{additions[v].DESC}, {
                                    Math.ceil(convertPrice((additions[v].VALUE || 0) * Math.max(1, invoiceData.additions[v] || 0) * invoiceData?.user_info?.contract_vat)) } {currencySymbol}</div>
                                </div>
                            }
                        />
                    )
                })
                : null
            }
        </div>
    )
}

const AdditionItemGetUp = ({setRefresh, additions, item, convertPrice = (price) => price}) => {
    const { invoiceData, setInvoiceData } = useInvoiceContext();
    const { t } = useTranslation('basic');
    const currencySymbol = getCurrencySymbol(invoiceData?.user_info);

    return (
        <div className="additionItem">
            <div className="additionItemWrapper">
                <div className={`additionItemHeader ${invoiceData.additions.GET_UP > 0 ? "active" : ""}`}>
                    <div className="paragraph-14R">{t('GET_UP')}</div>
                    <div className="paragraph-12R">
                        {
                            invoiceData.additions.GET_UP ?
                            !invoiceData.additions.GET_UP_FLOOR_BY_HAND ?
                            additions.GET_UP_FLOOR_BY_HAND.VALUE ?
                            Math.ceil(convertPrice(additions.GET_UP_FLOOR_BY_HAND.VALUE * Math.max(1, invoiceData.additions.GET_UP) * invoiceData?.user_info?.contract_vat)) + " " + currencySymbol
                            : t("free")
                            : additions.GET_UP_FLOOR_BY_ELEVATOR.VALUE ?
                            Math.ceil(convertPrice(additions.GET_UP_FLOOR_BY_ELEVATOR.VALUE * invoiceData?.user_info?.contract_vat)) + " " + currencySymbol
                            : t("free")
                            : ""
                        }
                    </div>
                </div>
                <div className="additionItemToggle">
                    <Toggle color="green" size="xs" checked={invoiceData.additions.GET_UP > 0} onChange={(e) => {
                        setInvoiceData(oldData => {

                            const newData = {...oldData};
                            if (e) {
                                newData.additions.GET_UP = 1;
                            } else {
                                delete newData.additions.GET_UP;
                                delete newData.additions.GET_UP_FLOOR_BY_HAND;
                            }
                            return newData
                        });
                        setRefresh(oldData => oldData + 1);
                    }} />
                </div>
            </div>
            {
                invoiceData.additions.GET_UP > 0 &&
                <><BasicNumberInput
                    fluid
                    spaced
                    value={invoiceData.additions.GET_UP}
                    onChange={(v, e) => {
                        setInvoiceData(oldData => {
                            const newData = {...oldData};
                            newData.additions.GET_UP = Math.min(999, parseInt(v)) || 0;
                            return newData
                        });
                        setRefresh(oldData => oldData + 1);
                    }}

                    label={t("floor")}
                />
                <BasicCheckbox
                    checked={invoiceData.additions.GET_UP_FLOOR_BY_HAND}
                    label={t("has_elevator")}
                    onChange={(v) => {
                        setInvoiceData(oldData => {
                            const newData = {...oldData};
                            newData.additions.GET_UP_FLOOR_BY_HAND = v;
                            return newData
                        });
                        setRefresh(oldData => oldData + 1);
                    }}
                />
                </>
            }
        </div>
    )
}

const AdditionItem = ({setRefresh, k, item, convertPrice = (price) => price}) => {
    const { invoiceData, setInvoiceData } = useInvoiceContext();
    const { t } = useTranslation('basic');
    const currencySymbol = getCurrencySymbol(invoiceData?.user_info);
    console.log("item.VALUE:", item.VALUE)
    console.log("VAT from invoiceData:", invoiceData.vat)
console.log("VAT from user_info:", invoiceData.user_info?.contract_vat)


    return (
        <div className="additionItem">
            <div className="additionItemWrapper">
                <div className={`additionItemHeader ${invoiceData.additions[k] > 0 ? "active" : ""}`}>
                    <div className="paragraph-14R">{t(k)}</div>
                    <div className="paragraph-12R">{
                        item.VALUE ?
                        item.TYPE == "int" && invoiceData.additions[k] ?
                        Math.ceil(convertPrice(item.VALUE * Math.max(1, invoiceData.additions[k]) * invoiceData?.user_info?.contract_vat)) + " " + currencySymbol
                        : Math.ceil(convertPrice(item.VALUE * invoiceData?.user_info?.contract_vat)) + " " + currencySymbol
                        : k == "LATHING" ? t("manager_will_inform_price") : t("free")}
                    </div>
                </div>
                <div className="additionItemToggle">
                    <Toggle color="green" size="xs" checked={
                        item.DISABLE_INPUT ? true :
                        Boolean(invoiceData.additions[k])
                    } onChange={(e) => {
                        setInvoiceData(oldData => {
                            if (item.DISABLE_INPUT) return oldData;

                            const newData = {...oldData};
                            if (e) {
                                if (item.TYPE == "bool") {
                                    newData.additions[k] = true;
                                }
                                if (item.TYPE == "int") {
                                    newData.additions[k] = 1;
                                }
                            } else {
                                delete newData.additions[k];
                            }
                            
                            return newData
                        });
                        setRefresh(oldData => oldData + 1);
                    }} />
                </div>
            </div>
            {   
                invoiceData.additions[k] > 0 && !item.DISABLE_INPUT &&
                (item.TYPE == "int" && 
                    <BasicNumberInput
                        fluid
                        spaced
                        value={invoiceData.additions[k] || 0}
                        onChange={(v) => {
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.additions[k] = v;
                                return newData
                            });
                            setRefresh(oldData => oldData + 1);
                        }}

                        label={LABELS[k]}
                    />
                )
            }
        </div>
    )
}

export default function InvoiceAdditions() {
    const { t } = useTranslation('basic');
    const { invoiceData, setInvoiceData } = useInvoiceContext();

    const [additions, setAdditions] = useState([]);
    const currencySymbol = getCurrencySymbol(invoiceData?.user_info);
    const [refresh, setRefresh] = useState(0);
    const [includesBoxes, setIncludesBoxes] = useState(false);
    const [currencyRate, setCurrencyRate] = useState(null); // KZT rate relative to RUB
    
    // Load currency rate for conversion
    useEffect(() => {
        const loadCurrencyRate = async () => {
            if (invoiceData?.user_info?.is_kz) {
                try {
                    const rate = await getCurrencyRate('KZT');
                    setCurrencyRate(rate.value); // e.g., 6.0 (1 RUB = 6 KZT)
                } catch (error) {
                    console.error('Failed to load currency rate:', error);
                    setCurrencyRate(6.0); // Fallback to mock rate
                }
            } else {
                setCurrencyRate(1.0); // RUB is base currency
            }
        };
        
        loadCurrencyRate();
    }, [invoiceData?.user_info?.is_kz]);
    
    // Convert price from RUB to contract currency
    const convertPrice = (priceInRub) => {
        if (!priceInRub || priceInRub === 0) return 0;
        // If currency rate is not loaded yet, return original price (will update when rate loads)
        if (currencyRate === null) return priceInRub;
        if (!invoiceData?.user_info?.is_kz || currencyRate === 1.0) {
            return priceInRub; // No conversion needed for RUB
        }
        return priceInRub * currencyRate; // Convert to KZT
    };
    
    // get additions
    useEffect(() => {
        let p = invoiceData.places.map((v, index) => {
            return {
                number: index + 1,
                height: v.height,
                length: v.length,
                width: v.width,
                weight: v.weight,
                goods: v.goods.map((good, index) => {
                    return {
                        article: good.article,
                        name: good.name,
                        price: good.insurance,
                        price_alter_vat: good.price,
                        quantity: good.count,
                        vat_rate: good.vat,
                        vat_sum: good.vat_sum,
                        weight: good.weight
                    }
                })
            }
        });
        getAdditions({invoiceForm: {
            places: p,
            selected_mode: invoiceData.selected_mode,
            contract_number: invoiceData.contract_number
        }}).then((res) => {
            let d = {...res};

            let heavyGood = false;
            let heaveHeavyGood = false;
            let total_weight = 0;

            p.map((place) => {
                total_weight += place.weight;
            });

            if (!invoiceData.tariff_name?.toLowerCase().includes("сборный груз")) {
                p.map((place) => {
                    if (place.weight >= 75 && place.weight <= 200) {
                        heavyGood = true;
                    }
                    if (place.weight > 200) {
                        heaveHeavyGood = true;
                    }
                });

                if (heavyGood) {
                    d.HEAVY_GOOD = {
                        DESC: "Тяжелые товары",
                        VALUE: 18,
                        TYPE: "int",
                        DISABLE_INPUT: true
                    };
                }

                if (heaveHeavyGood) {
                    d.HEAVY_GOOD = {
                        DESC: "Тяжелые товары",
                        VALUE: 25,
                        TYPE: "int",
                        DISABLE_INPUT: true
                    };
                }

                if (heaveHeavyGood || heavyGood) {
                    setInvoiceData(oldData => {
                        const newData = {...oldData};
                        newData.additions["HEAVY_GOOD"] = total_weight;
                        return newData
                    })
                }
            } else {
                if (d.HEAVY_GOOD) {
                    delete d.HEAVY_GOOD;
                }
                setInvoiceData(oldData => {
                    const newData = {...oldData};
                    if (newData.additions["HEAVY_GOOD"]) {
                        delete newData.additions["HEAVY_GOOD"];
                    }
                    return newData
                })
            }

            if (d.GET_UP_FLOOR_BY_ELEVATOR && !d.GET_UP_FLOOR_BY_HAND) {
                d.GET_UP_FLOOR_BY_HAND = d.GET_UP_FLOOR_BY_ELEVATOR;
            }

            setAdditions(d);

            if (res.BOX) {
                let include_boxes = false;
                
                Object.keys(res).map((v, i) => {
                    if (v.startsWith("CARTON_BOX")) {
                        include_boxes = true;
                    }
                });

                setIncludesBoxes(include_boxes);
            }
        })
    }, []);

    useEffect(() => {
        setRefresh(oldData => oldData + 1);
    }, [additions]);

    // Validate and clean up incompatible additions when additions data changes
    useEffect(() => {
        if (!additions || Object.keys(additions).length === 0) return;
        
        // Check if current additions are compatible with new cities/tariff
        const currentAdditions = invoiceData.additions || {};
        const incompatibleAdditions = [];
        
        Object.keys(currentAdditions).forEach(additionKey => {
            // Skip if this addition is not in the available additions list
            if (!additions[additionKey]) {
                incompatibleAdditions.push(additionKey);
                return;
            }
            
            // Check delivery mode compatibility for GET_UP
            if (additionKey === 'GET_UP' && ![1, 3].includes(invoiceData.selected_mode)) {
                incompatibleAdditions.push(additionKey);
                return;
            }
            
            // Check delivery mode compatibility for BOX
            if (additionKey === 'BOX' && ![3, 4].includes(invoiceData.selected_mode)) {
                incompatibleAdditions.push(additionKey);
                return;
            }
            
            // Check if HEAVY_GOOD should be hidden for "Сборный груз" tariff
            if (additionKey === 'HEAVY_GOOD' && invoiceData.tariff_name?.toLowerCase().includes("сборный груз")) {
                incompatibleAdditions.push(additionKey);
                return;
            }
        });
        
        // Remove incompatible additions
        if (incompatibleAdditions.length > 0) {
            setInvoiceData(oldData => {
                const newData = {...oldData};
                incompatibleAdditions.forEach(key => {
                    delete newData.additions[key];
                    // Also remove related additions
                    if (key === 'GET_UP') {
                        delete newData.additions.GET_UP_FLOOR_BY_HAND;
                    }
                    if (key === 'BOX') {
                        Object.keys(newData.additions).forEach(addKey => {
                            if (addKey.startsWith("CARTON_BOX")) {
                                delete newData.additions[addKey];
                            }
                        });
                    }
                });
                return newData;
            });
        }
    }, [additions, invoiceData.selected_mode, invoiceData.tariff_name, invoiceData.cityFrom, invoiceData.cityTo]);

    // calc additions sum
    useEffect(() => {
        let s = 0;
        let separated_prices = {};
        let additions_types = {};
        let extra_info = {};

        Object.keys(invoiceData.additions).map((v, i) => {
            if (v.startsWith("GET_UP")) {
                if (v.startsWith("GET_UP_")) return;

                console.log("B", invoiceData.additions[v])
                if (!additions.GET_UP_FLOOR_BY_HAND) return;

                if (invoiceData.additions[v] > 0) {
                    console.log("A")
                    if (!invoiceData.additions.GET_UP_FLOOR_BY_HAND) {
                        if (!additions.GET_UP_FLOOR_BY_HAND.VALUE) return;
                        s += additions.GET_UP_FLOOR_BY_HAND.VALUE * Math.max(1, invoiceData.additions.GET_UP);

                        separated_prices[v] = additions.GET_UP_FLOOR_BY_HAND.VALUE * Math.max(1, invoiceData.additions.GET_UP);
                        additions_types[v] = additions.GET_UP.TYPE;
                        extra_info[v] = "by_hand";
                    } else {
                        if (!additions.GET_UP_FLOOR_BY_ELEVATOR.VALUE) return;
                        s += additions.GET_UP_FLOOR_BY_ELEVATOR.VALUE;

                        separated_prices[v] = additions.GET_UP_FLOOR_BY_ELEVATOR.VALUE;
                        additions_types[v] = additions.GET_UP_FLOOR_BY_ELEVATOR.TYPE;
                        extra_info[v] = "by_elevator";
                    }
                }

                return;
            }

            if (v.startsWith("BOX")) return;
            if (v.startsWith("CARTON_BOX")) {
                if (invoiceData.additions[v] > 0) {
                    if (!additions[v]?.VALUE) return;
                    s += additions[v].VALUE * Math.max(1, invoiceData.additions[v]);

                    separated_prices[v] = additions[v].VALUE * Math.max(1, invoiceData.additions[v]);
                    additions_types[v] = additions[v].TYPE;
                }

                return;
            }

            if (invoiceData.additions[v] > 0) {
                if (!additions[v]?.VALUE) return;
                s += additions[v].VALUE * Math.max(1, invoiceData.additions[v]);

                separated_prices[v] = additions[v].VALUE * Math.max(1, invoiceData.additions[v]);
                additions_types[v] = additions[v].TYPE;
            }
        })

        setInvoiceData(oldData => {
            const newData = {...oldData};
            newData.additions_sum = s * (invoiceData?.user_info?.contract_vat || 1) * (invoiceData?.user_info?.is_kz ? (currencyRate || 1) : 1);
            newData.additions_separated_prices = separated_prices;
            newData.additions_types = additions_types;
            newData.additions_extra_info = extra_info;
            return newData
        });
    }, [refresh])

    return (
        <div className="invoiceAdditions">
            {
                Object.keys(additions).map(
                    (v, i) => {

                        if (v.startsWith("GET_UP")) {
                            if (v.startsWith("GET_UP_")) return;
                            if (![1,3].includes(invoiceData.selected_mode)) return;

                            return (
                                <AdditionItemGetUp setRefresh={setRefresh} additions={additions} item={additions[v]} convertPrice={convertPrice} />
                            )
                        }

                        if (v.startsWith("BOX")) {
                            if (![3,4].includes(invoiceData.selected_mode)) return;

                            if (!includesBoxes) return;

                            return (<AdditionItemBox setRefresh={setRefresh} additions={additions} convertPrice={convertPrice} />);
                        }

                        if (v.startsWith("CARTON_BOX")) return;

                        // Hide HEAVY_GOOD for "Сборный груз" tariff
                        if (v === "HEAVY_GOOD" && invoiceData.tariff_name?.toLowerCase().includes("сборный груз")) return;

                        return (
                            <AdditionItem setRefresh={setRefresh} k={v} item={additions[v]} convertPrice={convertPrice} />
                        )
                    }
                )
            }
            <div className="gradient_bg sum">
                <div className="line">
                    <span className="paragraph-14R">
                        {t("additional_services_cost")}
                    </span>
                    <span className="paragraph-14M">
                        {Math.ceil(invoiceData.additions_sum || 0)} {currencySymbol}
                    </span>
                </div>
                <div className="line">
                    <span className="paragraph-14R">
                        {t("delivery_sum")}
                    </span>
                    <span className="paragraph-14M">
                        {Math.ceil(invoiceData.delivery_sum || 0)} {currencySymbol}
                    </span>
                </div>
                <div className="line">
                    <span className="paragraph-16R">
                        {t("total")}
                    </span>
                    <span className="paragraph-16M">
                    {Math.ceil((invoiceData.additions_sum || 0) + (invoiceData.delivery_sum || 0))} {currencySymbol}
                    </span>
                </div>
            </div>
        </div>
    )
}